import { createApp } from 'vue';
import App from './App.vue';

// Vuetify
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

//Router
import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';

// Create router instance
const router = createRouter({
  history: createWebHistory(),
  routes,
});

import '@mdi/font/css/materialdesignicons.min.css';  // If you're importing it in JS


const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
  },
});

const app = createApp(App);
app.use(vuetify);
app.use(router);

app.mount('#app');